import type { CreateClientConfig } from "./client/client.gen";
import type { QuerySerializer } from "./client/core/bodySerializer.gen";

function appendQueryValue(params: string[], key: string, value: unknown): void {
	if (value === undefined || value === null) {
		return;
	}

	if (value instanceof Date) {
		params.push(
			`${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString())}`
		);
		return;
	}

	if (Array.isArray(value)) {
		value.forEach((item, index) => {
			if (item !== null && typeof item === "object") {
				appendQueryValue(params, `${key}[${index}]`, item);
				return;
			}
			appendQueryValue(params, key, item);
		});
		return;
	}

	if (typeof value === "object") {
		for (const [nestedKey, nestedValue] of Object.entries(value)) {
			appendQueryValue(params, `${key}[${nestedKey}]`, nestedValue);
		}
		return;
	}

	params.push(
		`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
	);
}

const querySerializer: QuerySerializer = (query) => {
	const params: string[] = [];
	for (const [key, value] of Object.entries(query)) {
		appendQueryValue(params, key, value);
	}
	return params.join("&");
};

/**
 * Runtime base config for the generated HTTP client.
 *
 * Override per-call via `client.setConfig({...})` if needed. In dev,
 * Vite's `/api` proxy forwards to the NestJS server at :4000 — the
 * default empty `baseUrl` means requests stay relative to the page
 * origin and the proxy handles routing.
 *
 * In production (Cloudflare Pages), set `VITE_BACKEND_URL` at build
 * time and consumers can `client.setConfig({ baseUrl: import.meta.env.VITE_BACKEND_URL })`
 * at app bootstrap.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
	...config,
	credentials: "include",
	querySerializer,
});
